import { logoutMaker } from 'utils/auth'

export const Logout = (): void => {
  const performLogout = async () => {
    try {
      await logoutMaker()
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      window.location.href = '/'
    }
  }

  performLogout().catch(logoutError => {
    console.error('Logout error:', logoutError)
  })
}
